import { defineComponent as _defineComponent } from 'vue'
import Status from '@/enum/Status';
import RequestsList, { RequestListProps } from '../RequestsList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const config: RequestListProps = {
  title: 'Consultar cotizaciones',
  subtitle: 'Aqui verás las solicitudes pendientes, preaprobadas y cotizadas.',
  columns: ['code', 'status', 'insured_fullname', 'address', 'netpayment', 'validity', 'actions'],
  filters: {
    initial:  {
      status: [Status.Pendiente, Status.Preaprobado, Status.Cotizado],
    },
    fields: ['seguredName', 'status', 'policy_number'],
    mainSearcher: 'seguredName',
  }
};

return { __sfc: true,config, RequestsList }
}

})